import { useState, useEffect } from "react";

import { useLoading } from './../LoadModal/script'
import { createPayment } from '../../../../shared/service';

/** Сумма для API: float с двумя знаками (как 123.50 в контракте), не целое. */
const toPaymentAmountFloat = (value) =>
  parseFloat(Number(value).toFixed(2));

export const usePayment = ({ provider, minAmount }) => {
  const { loader } = useLoading();
  const [errMsg, setErrMsg] = useState(false);
  const [apiError, setApiError] = useState('');
  const [modal, setModal] = useState(false);
  const state = () => {
    setApiError('');
    setModal((m) => !m);
  };

  const [amount, setAmount] = useState(0);
  const handleChangeInput = (e) => {
    const raw = e.target.value.trim().replace(',', '.');
    if (raw === '') {
      setAmount(0);
      return;
    }
    const value = Number.parseFloat(raw);
    if (!Number.isNaN(value)) {
      setAmount(value);
    }
  };

  useEffect(() => {
    const m = toPaymentAmountFloat(minAmount);
    setAmount(Number.isNaN(m) ? 0 : m);
  }, [minAmount]);

  const pay = async () => {
    const amountFloat = toPaymentAmountFloat(amount);
    if (Number.isNaN(amountFloat) || amountFloat <= 0) {
      setErrMsg(true);
      return;
    }
    setErrMsg(false);
    setApiError('');
    loader(true);
    try {
      const response = await createPayment({ provider, amount: amountFloat });
      let data = null;
      try {
        data = await response.json();
      } catch {
        data = null;
      }

      if (!response.ok) {
        const fromBody = data?.result;
        setApiError(
          (typeof fromBody === 'string' && fromBody)
            ? fromBody
            : `Ошибка сервера (${response.status}). Попробуйте позже.`
        );
        return;
      }

      const result = data?.result ?? '';
      if (result !== 'OK') {
        setApiError(result || 'Payment failed');
        return;
      }

      setModal(false);
      setApiError('');
    } catch (e) {
      console.error(e);
      setApiError('Сеть недоступна или ответ сервера некорректен.');
    } finally {
      setErrMsg(false);
      loader(false);
    }
  };

  return {
    modal,
    amount,
    errMsg,
    apiError,
    state,
    handleChangeInput,
    pay,
  };

};

